module.exports = __webpack_public_path__ + "img/carousel-5.a08e83fd.png";